import reducer from './reducers';

import * as SuspendSelectors from './selectors';
import * as SuspendOperations from './operations';
import * as SuspendTypes from './types';

export { SuspendSelectors, SuspendOperations, SuspendTypes };

export default reducer;
